import React, { useEffect } from "react";

const NAVBAR_H = 64;

const Navbar = ({ user, onLogout }) => {
  const handleLogout = () => {
    localStorage.clear();
    onLogout();
  };

  useEffect(() => {
    const handleUserInteraction = () => {
      const audio = new Audio("/notification.mp3");
      audio.play().catch(() => {});
      window.removeEventListener("click", handleUserInteraction);
    };
    window.addEventListener("click", handleUserInteraction);
    return () => window.removeEventListener("click", handleUserInteraction);
  }, []);

  const openSidebar = () => {
    window.dispatchEvent(new CustomEvent("sidebar:toggle"));
  };

  return (
    <div
      style={{
        height: NAVBAR_H,
        width: "100%",
        position: "fixed",
        top: 0,
        left: 0,
        backgroundColor: "#9fb6c3",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "0 12px",
        zIndex: 1200,
        boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
        boxSizing: "border-box",
        gap: 8,
      }}
    >
      {/* Mobile hamburger */}
      <button
        onClick={openSidebar}
        aria-label="Open menu"
        style={{
          display: window.innerWidth < 992 ? "inline-flex" : "none",
          alignItems: "center",
          justifyContent: "center",
          width: 36,
          height: 36,
          borderRadius: 8,
          border: "none",
          background: "#2E3267",
          color: "#fff",
          fontSize: 18,
          cursor: "pointer",
          marginRight: 6,
        }}
      >
        ☰
      </button>

      {/* Company Name */}
      <div
        style={{
          fontSize: 18,
          fontWeight: 700,
          color: "#343A76",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          flex: 1,
        }}
        title={user?.companyName || "Sheth Design Consultants LLP"}
      >
        {user?.companyName || "Sheth Design Consultants LLP"}
      </div>

      {/* Right Side */}
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        {user && (
          <span style={{ fontSize: 14, fontWeight: 700, whiteSpace: "nowrap" }}>
            Welcome, {user.name}
          </span>
        )}
        <button
          onClick={handleLogout}
          style={{
            backgroundColor: "#008080",
            color: "white",
            border: "none",
            padding: "8px 16px",
            borderRadius: "20px",
            cursor: "pointer",
          }}
        >
          Logout
        </button>
      </div>
    </div>
  );
};

export default Navbar;
